var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('section',[_c('div',{staticClass:"content"},[_c('IntroSection')],1)]),_c('section',{staticClass:"profile"},[_c('div',{staticClass:"content"},[_c('ProfileSection')],1)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }